module.exports = __webpack_public_path__ + "files/a01278d23efeffb854e31ac599499739.png";